import { useState } from "react";
import styled from "@xstyled/styled-components";

import { Question } from "..";

import { Button, Card, Heading, Modal } from "@otta/design";

type PreferencesReviewEditModalProps = {
  infos: Question;
  onClose: () => void;
};

const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  background-color: beige-100;

  padding-top: 80;
  padding-bottom: 85;
  max-width: 1120;
  max-height: 680;
  height: 100%;

  > div {
    width: 100%;
  }
`;

const Flex = styled.div`
  margin-top: 40;
  max-width: 550;
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: beige-100;

  padding-left: 40;
  padding-right: 40;
  width: 100%;
`;

const Footer = styled.footer`
  display: flex;
  justify-content: center;

  padding: 12;
  width: 100%;
  bottom: 0;
  position: fixed;
  background-color: white;
  z-index: 1;
`;

export const PreferencesReviewEditModal: React.FC<
  PreferencesReviewEditModalProps
> = props => {
  const { infos, onClose } = props;

  const [open, setOpen] = useState(true);

  const handleModalChange = (value: boolean) => {
    setOpen(value);
    if (!value) {
      onClose();
    }
  };

  const Component = infos.component;

  return (
    <StyledModal open={open} onOpenChange={handleModalChange}>
      <StyledCard>
        <Heading size={2} bold align="center">
          {infos.title}
        </Heading>
        <Flex>
          <Component
            handleNext={() => {
              // no-op default
            }}
            nextEnabled={false}
          />
        </Flex>
      </StyledCard>
      <Footer>
        <Button size="regular" level="secondary" onClick={onClose}>
          Close
        </Button>
      </Footer>
    </StyledModal>
  );
};
